export class Fields{
    public default!: string[]
}

export const emptyFields = {
    default: [] as string[]
}